import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/picto_CV.svg")